import { computeCaptureGeometry } from './capture-geometry';

/** JPEG quality used for all camera captures (shipping box/dropoff pictures). */
export const JPEG_CAPTURE_QUALITY = 0.9;
export const JPEG_MIME_TYPE = 'image/jpeg';

/**
 * Draws the current frame of `video` onto `canvas`, sizing the canvas to the frame's real
 * aspect ratio so the capture is never stretched.
 *
 * Replaces the previous hard-coded `drawImage(video, 0, 0, 1920, 1080)` / window-sized draws
 * that stretched non-16:9 frames. Returns false if the 2D context or frame is unavailable.
 */
export function drawVideoFrameToCanvas(canvas: HTMLCanvasElement, video: HTMLVideoElement): boolean {
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  const { videoWidth, videoHeight } = video;

  if (!ctx || !videoWidth || !videoHeight) {
    return false;
  }

  const geo = computeCaptureGeometry(videoWidth, videoHeight);
  canvas.width = geo.canvasWidth;
  canvas.height = geo.canvasHeight;
  ctx.drawImage(video, 0, 0, geo.canvasWidth, geo.canvasHeight);

  return true;
}
